<template>
  <!-- 新建楼层 -->
  <div class="form">
    <!-- 表单区域 -->
    <div class="container">
      <el-form ref="formRef" :model="formData" label-width="200px">
        <el-row>
          <!-- <el-col span="12">
            <el-form-item label="房间编号：">
              <div class="form-item-connector">
                <el-form-item>
                  <el-input v-model="formData.buildingCode" disabled></el-input>
                </el-form-item>
                <span>栋</span>
                <el-form-item>
                  <el-input v-model="formData.floorCode" disabled></el-input>
                </el-form-item>
                <span>层</span>
                <el-form-item>
                  <el-input v-model="formData.roomCode" disabled></el-input>
                </el-form-item>
                <span>号</span>
              </div>
            </el-form-item>
          </el-col> -->
          <el-col span="12" v-show="type == 'add'">
            <el-form-item
              prop="code"
              label="床位号："
              :rules="
                formRules.code.concat([
                  { required: true, message: '请输入床位号', trigger: 'blur' },
                ])
              "
            >
              <el-input
                v-model="formData.code"
                placeholder="请输入 床位号"
                maxlength="10"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col>
          <!-- <el-col span="12">
            <el-form-item
              prop="name"
              label="床位名称："
              :rules="[{ required: true, message: '请输入床位名称', trigger: 'blur' }]"
            >
              <el-input
                v-model="formData.name"
                placeholder="请输入 床位名称"
                maxlength="20"
                show-word-limit
                clearable
              ></el-input>
            </el-form-item>
          </el-col> -->
          <el-col span="12" v-show="type == 'add'">
            <el-form-item prop="bedConnector" label="连接符：" :rules="formRules.connector">
              <div class="form-item-connector">
                <span>房间号</span>
                <el-input v-model="formData.bedConnector" clearable></el-input>
                <span>床位号</span>
              </div>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="bedTypeId"
              label="床位类型："
              :rules="[{ required: true, message: '请选择床位类型', trigger: 'change' }]"
            >
              <el-select
                v-model="formData.bedTypeId"
                placeholder="请选择 床位类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in bedTypes"
                  :key="index"
                  :label="item.name"
                  :value="item.id"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="towardType"
              label="床位朝向："
              :rules="[{ required: true, message: '请选择床位朝向', trigger: 'change' }]"
            >
              <el-select
                v-model="formData.towardType"
                placeholder="请选择 床位朝向"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in dirDict"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col span="12">
            <el-form-item
              prop="nursingType"
              label="护理类型："
              :rules="[{ required: true, message: '请选择护理类型', trigger: 'change' }]"
            >
              <el-select
                v-model="formData.nursingType"
                placeholder="请选择 护理类型"
                clearable
                style="width: 100%"
              >
                <el-option
                  v-for="(item, index) in nurseTypeDict"
                  :key="index"
                  :label="item.dictValue"
                  :value="item.dictKey"
                ></el-option>
              </el-select>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 按钮占位区域 -->
    <div class="placeholder"></div>
    <!-- 按钮 -->
    <div class="btn">
      <el-button type="primary" size="small" @click="doSave">
        {{ type == 'add' ? '提交' : '修改' }}
      </el-button>
      <el-button size="small" @click="doClose">取消</el-button>
    </div>
  </div>
</template>

<script>
import { addBedApi, updateBedApi } from '../api/bedManage';
import mixin from './mixin';

export default {
  name: 'BuildingForm',
  mixins: [mixin],
  data() {
    return {
      // 将本地变量转成实例属性，否则mixin里无法访问到
      addApi: addBedApi,
      updateApi: updateBedApi,
    };
  },
  created() {
    if (this.type == 'add') {
      this.formData = Object.assign(
        {
          // name: '',
          bedConnector: '',
          code: '',
          towardType: '',
          bedTypeId: '',
          nursingType: '',
        },
        this.rowData
      );
    } else {
      this.formData = this.rowData;
    }
  },
};
</script>

<style lang="scss" scoped>
@import './common.scss';
</style>
